export const wrapperStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '2px',
  minWidth: 0,
  paddingY: '4px',
};

export const titleRowStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
  minWidth: 0,
};

export const numberChipStyles = {
  flexShrink: 0,
  paddingX: '6px',
  borderRadius: '4px',
  backgroundColor: ({ palette }) => palette.background.default,
  color: ({ palette }) => palette.text.secondary,
};

export const clampedTextStyles = {
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
  wordBreak: 'break-word',
};

export const titleTextStyles = {
  minWidth: 0,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};
